export enum problemStatuses {
  NEW = "new",
  PROCESS = "process",
  REJECTED = "rejected",
  USER_REJECTED = "user_rejected",
  CLOSED = "closed",
  COMPLETED = "completed",
  DELETED = "deleted"
}